import {Component, Element, Event, EventEmitter, h, Host, Listen, Method, Prop, State} from '@stencil/core';
import '@justinribeiro/lite-youtube';

@Component({
  tag: 'bam-yt-video',
  styleUrl: 'bam-yt-video.scss',
})
export class BamYtVideoRefactor {
  @Element() host: HTMLElement;
  @Prop({ reflect: true, mutable: true }) videoId: string;
  @Prop() playerId: string;
  @Prop() enableJsApi: string = '1';
  @Prop() autoplay: string = '1';
  @Prop() controls: string = '1';
  @Prop() modestBranding: string = '0';
  @Prop() rel: string = '0';
  @Prop() loop: string = '1';
  @Prop() cookieText = '';
  @Prop() cookieButtonText = '';
  @Prop() cookieHeadline = '';
  @Prop() editMode = false;
  @Prop() short = false
  private params: string;
  private onetrustReady: boolean = false;
  private liteYoutube: HTMLElement;
  @State() hasConsent: boolean = window['OnetrustActiveGroups']?.includes('C0003');
  @Event() consentChange: EventEmitter;

  componentWillLoad() {
    const ytVideoId = this.videoId;
    const startTime = ytVideoId.indexOf('?t=') > -1 ? `${ytVideoId.substring(ytVideoId.indexOf('?') + 3)}` : '';
    this.videoId = startTime !== '' ? `${ytVideoId.substring(0, ytVideoId.indexOf('?'))}` : ytVideoId;
    this.params =
      `start=${startTime}&` +
      `autoplay=${this.autoplay}&` +
      `modestbranding=${this.modestBranding}&` +
      `rel=${this.rel}&` +
      `loop=${this.loop}&` +
      `playlist=${this.videoId}&` +
      `controls=${this.controls}&` +
      `enablejsapi=${this.enableJsApi}`;
  }

  @Listen('liteYoutubeIframeLoaded', { target: 'window' })
  onLiteYoutubeIframeLoaded(event) {
    if (event.target.id === this.playerId) {
      setTimeout(() => {
        this.play();
      }, 500);
    }
  }

  @Listen('pauseYoutube', { target: 'window' })
  onPauseYoutube() {
    this.pause();
  }

  @Listen('optanon.ready', { target: 'window' })
  onOptanonReady() {
    if (!this.onetrustReady) {
      if (window['OneTrust']) {
        window['OneTrust'].OnConsentChanged(this.consentChange.emit);
        this.onetrustReady = true;
        this.setConsentState();
      }
    }
  }

  @Listen('consentChange', { target: 'window' })
  onConsentChange() {
    this.setConsentState();
  }

  setConsentState() {
    this.hasConsent = window['OnetrustActiveGroups']?.includes('C0003');
  }

  handleButtonClick = () => {
    if (window['OneTrust']) {
      window['OneTrust'].UpdateConsent('Category', 'C0003:1');
      setTimeout(() => {
        window['OneTrust'].Close();
      }, 17);
    } else {
      console.warn('OneTrust is not on window active!');
    }
  };

  @Method()
  async pause(): Promise<void> {
    if (this.liteYoutube) {
      if (this.liteYoutube['domRefFrame']?.querySelector('iframe')) {
        this.liteYoutube['domRefFrame'].querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
    }
  }

  @Method()
  async play(): Promise<void> {
    if (this.liteYoutube) {
      if (this.liteYoutube['domRefFrame']?.querySelector('iframe')) {
        this.liteYoutube['domRefFrame'].querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      }
    }
  }

  private renderCookieConsent = () => (
    <div class="consent">
      <bal-card fullheight={true}>
        <bal-card-content>
          <div class="flex justify-content-start flex-direction-column">
            <bal-heading level="h4" space="bottom">
              {this.cookieHeadline}
            </bal-heading>
            <bal-text class="mb-normal">
              {this.cookieText}
              <bal-button flat={true} class="button is-link" color="link" onClick={this.handleButtonClick}>
                {this.cookieButtonText}
              </bal-button>
            </bal-text>
          </div>
        </bal-card-content>
      </bal-card>
    </div>
  );

  render() {
    return (
      <Host>
        {this.editMode || this.hasConsent ? (
          <lite-youtube
            ref={(el) => this.liteYoutube = el as HTMLElement}
            id={this.playerId}
            videoid={this.videoId}
            params={this.params}
            short={this.short}
          />
        ) : (
          this.renderCookieConsent()
        )}
      </Host>
    );
  }
}
